import LinkedList from './LinkedList';

export default LinkedList;
